<script lang="ts">
  import { getStr } from '../../../common/util';
  import { productDetailMainData } from '../store/pdp_store';

  export let productCode: string;
  export let alertType: string = 'PRICE';
  export let url: string = '/notifyForm';
  export let contextPath: string = window['ACC'].config.encodedContextPath;
</script>

<div
  class="price-alert js-product-price-alert mdc-typography--body2"
  data-product={productCode}
  data-url={url}
  data-alerttype={alertType}
  data-context={contextPath}
>
  <span class="c_icon_new c_icon_new--notification price_alert_icon"></span>
  {#if !$productDetailMainData.isMarketPlaceProduct}
    {getStr('extra.pricealertbutton')}
  {/if}
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .price-alert {
    cursor: pointer;
  }
  .mdc-typography--body2 {
    align-items: center;
    background-color: transparent;
    box-shadow: none;
    color: $tertiary-blue-02;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    gap: 4px;
    justify-content: center;
    line-height: 18px;
    text-transform: capitalize;
  }

  @include desktop-max-width {
    .parent-div {
      background-color: $primary-white;
      position: sticky;
      bottom: 0;
      box-shadow: 0px -8px 12px transparentize($secondary-gray-02, (1 - 0.32));

      .mdc-typography--body2 {
        font-size: 14px;
        line-height: 16px;
        text-transform: capitalize;
        white-space: nowrap;
      }
    }
  }
</style>
